// extracted by mini-css-extract-plugin
export default {"main":"AIMarkingPartition_main__Pu-EZ"};